import { useIntl } from 'react-intl'

const DEFAULT = 'de'
const LOCALE_KEY = 'locale'

export const setLocale = (locale) => {
  localStorage.setItem(LOCALE_KEY, locale)
}

export const getLocale = () => localStorage[LOCALE_KEY] || DEFAULT
export const hasLocale = () => localStorage[LOCALE_KEY] !== undefined

export const useMessage = (id) => {
  const intl = useIntl()
  return intl.formatMessage({ id })
}
